import React from 'react'
import PropTypes from 'prop-types'
import { RatioBox } from '../RatioBox'

const ImageBox = ({ src, ...props }) => (
  <RatioBox.InnerBox
    backgroundRepeat="no-repeat"
    backgroundImage={`url('${src}')`}
    {...props}
  />
)

ImageBox.defaultProps = {
  backgroundPosition: 'center center',
  backgroundSize: 'cover',
}

ImageBox.propTypes = {
  backgroundPosition: PropTypes.string,
  backgroundSize: PropTypes.string,
  src: PropTypes.string.isRequired,
}

export const RatioImage = React.memo(({
  backgroundPosition,
  backgroundSize,
  h,
  src,
  w,
  ...restProps
}) => (
  <RatioBox.OuterBox h={h} w={w} {...restProps}>
    <ImageBox
      backgroundPosition={backgroundPosition}
      backgroundSize={backgroundSize}
      src={src}
    />
  </RatioBox.OuterBox>
))

RatioImage.displayName = 'RatioImage'
RatioImage.ImageBox = ImageBox

RatioImage.defaultProps = {
  ...ImageBox.defaultProps,
}

RatioImage.propTypes = {
  ...ImageBox.propTypes,
  h: PropTypes.number,
  w: PropTypes.number,
}
